import { useState } from "react"
import { IRecord } from "../types/schema"
import { useAsyncEffect } from "./useAsyncEffect"

export function useProductGroupRebates({
  customerId,
  productIds,
}: {
  customerId?: string
  productIds?: string[]
}) {
  const skeem = window.skeem
  const [state, setState] = useState<Record<string, number | null>>({})
  useAsyncEffect(async () => {
    if (!customerId || !productIds) {
      return
    }
    const customer = await skeem.fetch2<IRecord<"customers", "default_rebate_percent">>({
      first: {
        name: "customers",
        matches: { id: customerId },
        attributes: ["default_rebate_percent"],
      },
    })
    const products = await skeem.fetch2<
      (IRecord<"products"> & {
        rebatePercent: number | null
      })[]
    >({
      model: {
        name: "products",
        attributes: [
          {
            as: "rebatePercent",
            value: {
              first: {
                path: [
                  "product_group",
                  { name: "product_group_rebates", filter: { matches: { customer: customerId } } },
                  "percentage",
                ],
              },
            },
          },
        ],
        filter: { matches: { id: { or: productIds } } },
      },
    })
    setState(
      products.reduce((rebates, product) => {
        rebates[product.id] = product.rebatePercent ?? customer.default_rebate_percent ?? null
        return rebates
      }, {} as typeof state),
    )
  }, [JSON.stringify(productIds), customerId])
  return state
}
